// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Settings_wrap__1I563","settings":"Settings_settings__1LHCp","menu":"Settings_menu__1gbi8"};